import { FileRecord } from "@/models/club";
import { useGetImage } from "@/utilities/helper/getImage";
import { Avatar } from "@mantine/core";
import React from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  fileRecord: FileRecord;
  firstName: string;
  lastName?: string;
  color: string;
  id: number;
  layout?: "column" | "row";
};

function UserHeaderComponent({ fileRecord, firstName, lastName, color, id, layout = "column" }: Props) {
  const { imageUrl } = useGetImage({ image: fileRecord });
  const navigate = useNavigate();
  const openProfile = () => navigate(`/dashboard/teams/teamMembers/detail/${id}`);
  return (
    <div
      role="button"
      tabIndex={0}
      className="calendar-member"
      data-layout={layout}
      aria-label={`مشاهدهٔ ${firstName}`}
      title={[firstName, lastName].filter(Boolean).join(" ")}
      style={{ "--member-color": color || "var(--mantine-color-gray-4)" } as React.CSSProperties}
      onClick={openProfile}
      onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); openProfile(); } }}
    >
      <Avatar radius="xl" size={layout === "row" ? 34 : 28} src={imageUrl} color="myColor" className="calendar-member-avatar">
        {firstName?.charAt(0) || ""}
      </Avatar>
      <span className="calendar-member-text">
        <span className="calendar-member-name">{firstName}</span>
        {lastName ? <span className="calendar-member-sub">{lastName}</span> : null}
      </span>
    </div>
  );
}

// Compare by value so new image object with same fileName doesn't trigger re-render/refetch
function arePropsEqual(prev: Props, next: Props): boolean {
  return (
    prev.id === next.id &&
    prev.firstName === next.firstName &&
    prev.lastName === next.lastName &&
    prev.color === next.color &&
    prev.layout === next.layout &&
    prev.fileRecord?.fileName === next.fileRecord?.fileName &&
    prev.fileRecord?.id === next.fileRecord?.id
  );
}

const UserHeader = React.memo(UserHeaderComponent, arePropsEqual);
UserHeader.displayName = "UserHeader";
export default UserHeader;
